let tooltipEl = null

function removeTooltip() {
  if (tooltipEl) {
    tooltipEl.remove()
    tooltipEl = null
  }
}

function showTooltip(el) {
  const text = el.getAttribute('data-overflow-tooltip')
  if (!text) return

  removeTooltip()
  tooltipEl = document.createElement('div')
  tooltipEl.className = 'overflow-tooltip-popup'
  tooltipEl.textContent = text
  document.body.appendChild(tooltipEl)

  const rect = el.getBoundingClientRect()
  const tipRect = tooltipEl.getBoundingClientRect()
  const left = Math.max(8, rect.left + rect.width / 2 - tipRect.width / 2)
  const top = rect.top - tipRect.height - 6
  tooltipEl.style.left = left + 'px'
  tooltipEl.style.top = (top < 8 ? rect.bottom + 6 : top) + 'px'
}

function check(el) {
  if (el.scrollWidth > el.offsetWidth) {
    el.setAttribute('data-overflow-tooltip', el.textContent.trim())
  } else {
    el.removeAttribute('data-overflow-tooltip')
  }
}

export default {
  mounted(el) {
    check(el)
    el._otEnter = () => showTooltip(el)
    el._otLeave = removeTooltip
    el.addEventListener('mouseenter', el._otEnter)
    el.addEventListener('mouseleave', el._otLeave)
  },
  updated(el) {
    check(el)
  },
  beforeUnmount(el) {
    el.removeEventListener('mouseenter', el._otEnter)
    el.removeEventListener('mouseleave', el._otLeave)
    removeTooltip()
  },
}
